import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListProd = createAsyncThunk(
  "ProductNameList/fetchListProd",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/mstproducts/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const ProductNameListSlice = createSlice({
  name: "ProductNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListProd.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListProd.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListProd.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default ProductNameListSlice.reducer;
